<template>
  <v-card
    elevation="0"
    class="rounded-lg pa-0 w-100 h-100"
    style="overflow-y: auto"
  >
    <v-card-title class="px-lg-3 py-lg-2 d-flex justify-space-between">
      <h6 class="text-caption mr-1 font-weight-bold">
        {{ $helper.isCompanyHasItems() ? "Order Item Info" : "Order Info" }}
      </h6>

      <SecondaryButton
        id="ordersShowMore"
        x-small
        btnClass="text-uppercase"
        depressed
        name="Show More"
        @click="$emit('orderList')"
      >
      </SecondaryButton>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col cols="7" class="d-flex justify-center" style="height: 100px">
          <VehicleUtilization :data="vehicleUtilizationPer" />
        </v-col>
        <v-col cols="5">
          <v-row class="ma-0" no-gutters>
            <v-col cols="12" class="d-flex pb-3" v-if="dataObj.volume">
              <BoxIconWithText
                icon="mdi-cube"
                :title="`Total Volume`"
                :text="dataObj.volume"
              />
            </v-col>
            <v-col cols="12" class="d-flex" v-if="dataObj.weight">
              <BoxIconWithText
                icon="mdi-weight"
                :title="`Total weight`"
                :text="dataObj.weight"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import { itemModule } from "@/utils/moduleMapping";
import BoxIconWithText from "@/components/BaseComponents/BoxIconWithText.vue";
import VehicleUtilization from "@/components/BaseComponents/VehicleUtilization.vue";
export default {
  components: {
    BoxIconWithText,
    VehicleUtilization,
  },
  props: {
    dataObj: {
      required: true,
    },
    vehicleUtilizationPer: {
      required: true,
    },
  },
  data() {
    return {
      itemModule,
    };
  },
};
</script>
